import { axiosInstance } from "../../../axios/axiosInstance";

const API_TICKET_MANAGEMENT_URL = "admin/support-tickets";
const API_TICKET_MANAGEMENT_MODULE_LIST_URL = API_TICKET_MANAGEMENT_URL + "/list";
const API_UPDATE_TICKET_MANAGEMENT_STATUS_URL = API_TICKET_MANAGEMENT_URL + "/update";
const API_GET_TICKET_MANAGEMENT_BY_ID_URL = API_TICKET_MANAGEMENT_URL + "/view";
const AP_START_TICKET_MANAGEMENT_CHAT_CONVERSATION_URL = API_TICKET_MANAGEMENT_URL + "/start_chat_conversation";

const API_CHAT_CONVERSATION_URL = "admin/chat-conversation";
const API_GET_CHAT_CONVERSATION_BY_ID_URL = API_CHAT_CONVERSATION_URL + "/view";
const AP_SEND_CHAT_CONVERSATION_URL = API_CHAT_CONVERSATION_URL + "/chat_message";

export const getTickets = (dataToBeSent) => {
  return axiosInstance.get(`${API_TICKET_MANAGEMENT_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}&status=${dataToBeSent?.status || ""}&role=${dataToBeSent?.role || ""}`);
};

export const getTicketManagementById = ({selectedTicketManagementId}) => {
  return axiosInstance.get(API_GET_TICKET_MANAGEMENT_BY_ID_URL + "/" + selectedTicketManagementId);
};

export const updateTicketStatus = ({selectedTicketId, ...rest}) => {
  return axiosInstance.post(API_UPDATE_TICKET_MANAGEMENT_STATUS_URL + "/" + selectedTicketId, rest);
};

export const startSupportTicketChatConversation = ({selectedTicketManagementId, ...rest}) => {
  return axiosInstance.post(AP_START_TICKET_MANAGEMENT_CHAT_CONVERSATION_URL + "/" + selectedTicketManagementId, rest);
};

export const getTicketManagementChatById = (dataToBeSent) => {
  return axiosInstance.get(API_GET_CHAT_CONVERSATION_BY_ID_URL + "/" + dataToBeSent?.selectedConversationId);
};

export const sendSuperAdminChatMessage = ({conversation_id, ...rest}) => {
  return axiosInstance.postForm(AP_SEND_CHAT_CONVERSATION_URL + "/" + conversation_id, rest);
};
